<template>
    <div>
        <Head title="Create Order"/>
        <h1 class="mb-8 text-3xl font-bold">
            <Link class="text-indigo-400 hover:text-indigo-600" href="/orders">Orders</Link>
            <span class="text-indigo-400 font-medium">/</span> Create
        </h1>
        <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="store">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">

                    <select-input v-model="form.customer" :error="form.errors.customer"
                                  class="pb-8 pr-6 w-full lg:w-1/2" label="Customer">
                        <option>select Customer</option>
                        <option v-for="customer in customers" v-bind:value="customer.id">
                            {{ customer.name }}
                        </option>
                    </select-input>


                    <select-input v-model="form.project" :error="form.errors.project" class="pb-8 pr-6 w-full lg:w-1/2"
                                  label="Project">
                        <option v-for="project in projects" v-bind:value="project.id">
                            {{ project.name }}
                        </option>
                    </select-input>
                    <text-input v-model="form.amount" :error="form.errors.amount" class="pb-8 pr-6 w-full lg:w-1/2"
                                label="Amount"/>

                    <select-input v-model="form.payment_status" :error="form.errors.payment_status"
                                  class="pb-8 pr-6 w-full lg:w-1/2"
                                  label="is the order Paid? ">
                        <option>Yes</option>
                        <option>No</option>
                    </select-input>

                    <select-input v-model="form.payment_method" v-bind:value="form.payment_method"
                                  :error="form.errors.payment_method"
                                  class="pb-8 pr-6 w-full lg:w-1/2"
                                  label="Payment Method">
                        <option value="mpesa" selected>Mpesa</option>
                        <option value="paypal">Paypal</option>
                    </select-input>

                    <text-input v-model="form.reference" :error="form.errors.reference"
                                class="pb-8 pr-6 w-full lg:w-1/2"
                                label="Payment Reference"/>

                    <textarea-input v-model="form.description" :error="form.errors.description"
                                    class="pb-8 pr-6 w-full lg:w-1/2"
                                    label="Description"/>
                </div>
                <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create Order
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";
import TextareaInput from "@/Shared/TextareaInput";

export default {
    components: {
        TextareaInput,
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
    },
    props:
        {
            customers: Object,
            projects: Object,
        },
    layout: Layout,
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                customer: null,
                project: null,
                reference: null,
                description: null,
                amount: null,
                payment_status: null,
                payment_method: null,
            }),
        }
    },
    methods: {
        store() {
            this.form.post('/orders')
        },
    },
}
</script>
